import {FormEvent, useState} from 'react'
import {Button, Modal} from 'react-bootstrap'

interface IProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => Promise<void> | void
  refetch: () => void
  title: string
  body: React.ReactNode
  confirmText?: React.ReactNode
  confirmVariant?: 'primary' | 'danger' | 'success' | 'warning'
}

export const ModalConfirmation: React.FC<IProps> = ({
  isOpen,
  onClose,
  onConfirm,
  refetch,
  title,
  body,
  confirmText = 'Confirm',
  confirmVariant = 'primary',
}) => {

  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await onConfirm()        // Ejecuta confirmación lógica (mutación, etc.)
      refetch()                // Refresca datos
      onClose()                // Cierra modal sólo si todo salió bien
    } catch (err) {
      console.error('Error en onConfirm:', err)
      // Aquí podrías mostrar un toast o mensaje dentro del modal
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal show={isOpen} onHide={onClose} backdrop='static' keyboard={false}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={onClose}>
            Cancel
          </Button>
          <Button type='submit' variant={confirmVariant} disabled={loading}>
            {loading ? 'Processing...' : confirmText}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
